import http from "../core/api/httpClient";

export interface LeadConsultationBookingResponse {
  lead_id: string;
  lead_number: string;
  first_name: string;
  last_name: string;
  email: string;
  consultation_date: string | null;
  consultation_time_slot: string | null;
  consultation_notes: string | null;
  qualification_outcome: string | null;
  free_eligibility_consultation_done_at?: string | null;
  status: string;
  updated_at: string;
}

export interface LeadConsultationBookingPayload {
  consultation_date: string;
  consultation_time_slot: string;
}

export const consultationBookingService = {
  async getLeadConsultationBooking(leadId: string): Promise<LeadConsultationBookingResponse> {
    const response = await http.get<LeadConsultationBookingResponse>(`/leads/${leadId}`);
    return response.data;
  },

  async saveLeadConsultationBooking(
    leadId: string,
    payload: LeadConsultationBookingPayload
  ): Promise<LeadConsultationBookingResponse> {
    const response = await http.post<LeadConsultationBookingResponse>(
      `/leads/${leadId}/consultation/book`,
      {
        consultation_date: payload.consultation_date,
        consultation_time_slot: payload.consultation_time_slot,
      }
    );
    return response.data;
  },
};
